@if (isLoading()) {
  <div class="global-spinner-overlay" role="status" aria-label="Cargando">
    <div class="global-spinner-wrapper">
      <span class="global-spinner-ring"></span>
      <span class="global-spinner-label">Cargando...</span>
    </div>
  </div>
}
